module.exports = __webpack_public_path__ + "static/media/species_dummy.18f99384.svg";